import React from 'react';

import ReactPaginate from 'react-paginate';

import RightIcon from 'material-ui/svg-icons/navigation/chevron-right';
import LeftIcon from 'material-ui/svg-icons/navigation/chevron-left';

import './IncidentHistoryTimelinePager.css';

const IncidentHistoryTimelinePager = props => {
  const onChange = data => {
    props.onChange(data.selected);
  };

  return (
    <div className="react-paginate">
      <ReactPaginate
        pageRangeDisplayed={3}
        marginPagesDisplayed={2}
        previousLabel={<LeftIcon />}
        nextLabel={<RightIcon />}
        pageCount={props.pages}
        onPageChange={onChange}
      />
    </div>
  );
};

export default IncidentHistoryTimelinePager;



// WEBPACK FOOTER //
// ./src/components/incidents/IncidentDetails/IncidentHistoryTimelinePager.js